import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Loader2, Gift as GiftIcon, CheckCircle2 } from "lucide-react";

const NAME_KEY = "mb_gift_name";

export const GiftNameDialog = ({ open, onOpenChange, title, description, cta, mark = false, accent, onConfirm }) => {
  const [by, setBy] = useState(() => localStorage.getItem(NAME_KEY) || "");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setBy((cur) => cur || localStorage.getItem(NAME_KEY) || ""); }, [open]);
  const valid = by.trim().length >= 2;

  const confirm = async () => {
    if (!valid) return;
    localStorage.setItem(NAME_KEY, by.trim());
    setBusy(true);
    try { await onConfirm({ by: by.trim(), message: message.trim() || null }); setMessage(""); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={mark ? "gift-mark-dialog" : "gift-name-dialog"} className="sm:max-w-md bg-[#FFFBF7] border-[#F0DDD3]">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#2D2825]">{title}</DialogTitle>
          <DialogDescription className="text-[#8C7F78]">{description}</DialogDescription>
        </DialogHeader>
        <div className="rounded-2xl border border-dashed border-[#E5A8A0] bg-white p-4 space-y-3">
          <Input data-testid={mark ? "gift-mark-name" : "gift-name-input"} value={by} maxLength={40} onChange={(e) => setBy(e.target.value)}
            placeholder="Il tuo nome *" className="rounded-xl bg-[#FAF8F5] border-[#EAE3DC] font-serif" />
          <textarea data-testid={mark ? "gift-mark-message" : "gift-message-input"} value={message} maxLength={200} rows={3}
            onChange={(e) => setMessage(e.target.value)} placeholder="Un pensiero per la mamma (facoltativo)"
            className="w-full rounded-xl bg-[#FAF8F5] border border-[#EAE3DC] px-3 py-2 text-sm outline-none focus:border-[#E5A8A0] resize-none" />
          <div className="text-[11px] text-[#8C7F78] text-right">{message.length}/200 · nome e messaggio li vedrà solo la mamma</div>
        </div>
        <button data-testid={mark ? "gift-mark-confirm" : "gift-name-confirm"} onClick={confirm} disabled={!valid || busy}
          className="inline-flex items-center justify-center gap-2 rounded-full text-white py-3 text-sm font-medium disabled:opacity-50 transition-opacity"
          style={{ background: accent }}>
          {busy ? <Loader2 className="animate-spin" size={16} /> : mark ? <CheckCircle2 size={16} /> : <GiftIcon size={16} />} {cta}
        </button>
      </DialogContent>
    </Dialog>
  );
};
